import type { FC } from "react";

export const ShareIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M13 10C12.44 10 10.02 10.57 8.5 11.93C6.98 10.58 4.56 10 4 10C3.45 10 3 10.45 3 11C3 11.38 3.22 11.72 3.5 11.9C3.82 12.1 5.71 12.96 8.5 14.07C11.29 12.96 13.18 12.1 13.5 11.9C13.78 11.72 14 11.38 14 11C14 10.45 13.55 10 13 10ZM8.5 2L5.5 5H7.5V10H9.5V5H11.5L8.5 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

